var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { slot: "detail", model: _vm.model },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                { attrs: { disabled: _vm.formDisabled } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["eletronicSigned.processNo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "",
                              disabled: _vm.isDisabled
                            },
                            model: {
                              value: _vm.model.process_no,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "process_no", $$v)
                              },
                              expression: "model.process_no"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["eletronicSigned.startTime"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.isDisabled,
                              format: _vm.dateFormat,
                              getCalendarContainer: function(node) {
                                return node.parentNode
                              }
                            },
                            model: {
                              value: _vm.model.start_time_java,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "start_time_java", $$v)
                              },
                              expression: "model.start_time_java"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-tabs",
                {
                  attrs: {
                    "default-active-key": "1",
                    size: "large",
                    "tab-bar-style": {
                      marginBottom: "24px",
                      paddingLeft: "16px"
                    }
                  },
                  on: { change: _vm.changeTabs }
                },
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: "1",
                      style:
                        _vm.innerFullscreen === false
                          ? _vm.setEdit === true
                            ? "max-height: 32vh;overflow:scroll"
                            : "max-height: 45vh;overflow:scroll"
                          : _vm.setEdit === true
                          ? "max-height: 60vh;overflow:scroll"
                          : "max-height: 65vh;overflow:scroll",
                      attrs: { loading: "true", tab: _vm.tabName }
                    },
                    [
                      _vm.processModel.applicationCode === "env_audit"
                        ? _c(
                            "div",
                            [
                              _c("danger-sign-form", {
                                ref: "applicationModel",
                                attrs: {
                                  formNo: _vm.ipsys_aid,
                                  formCode: _vm.formCode
                                }
                              }),
                              _c("a-form-model-item", {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.processModel.applicationCode === "ipsys"
                        ? _c("div", [
                            _vm.processModel.modelCode ===
                              "IpsTrademarkUserReport" ||
                            _vm.processModel.modelCode ===
                              "IpsTrademarkUserReportC"
                              ? _c(
                                  "div",
                                  [
                                    _c("s-tm-apply", {
                                      ref: "applicationModel",
                                      attrs: {
                                        "apply-no": _vm.ipsys_aid,
                                        pageType: _vm.pageType
                                      },
                                      on: {
                                        ok: function($event) {
                                          return _vm.$emit("ok")
                                        }
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.processModel.modelCode ===
                            "IpsTrademarkApplyRegister"
                              ? _c(
                                  "div",
                                  [
                                    _c("tm-apply", {
                                      attrs: {
                                        idFormNo: _vm.ipsys_aid,
                                        pageType: _vm.pageType
                                      },
                                      on: {
                                        ok: function($event) {
                                          return _vm.$emit("ok")
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.processModel.modelCode ===
                            "IpsTrademarkRetrieve"
                              ? _c(
                                  "div",
                                  [
                                    _c("tm-retrieve", {
                                      attrs: {
                                        idFormNo: _vm.ipsys_aid,
                                        pageType: _vm.pageType
                                      },
                                      on: {
                                        ok: function($event) {
                                          return _vm.$emit("ok")
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.processModel.applicationCode === "ipsystur"
                        ? _c("div", [
                            _vm.processModel.modelCode == "IpsTechnologProposal"
                              ? _c(
                                  "div",
                                  [
                                    _c("request-proposal", {
                                      attrs: { idFormNo: _vm.ipsys_aid },
                                      on: {
                                        handleCloseModal: function($event) {
                                          return _vm.$emit("ok")
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.processModel.modelCode ===
                              "IpsTechnologyDisclosureEvaluate" ||
                            _vm.processModel.modelCode ==
                              "IpsTechnologyDisclosureEvaluateB"
                              ? _c(
                                  "div",
                                  [
                                    _c("layout-evaluation", {
                                      attrs: { idFormNo: _vm.ipsys_aid },
                                      on: {
                                        handleCloseModal: function($event) {
                                          return _vm.$emit("ok")
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.processModel.applicationCode === "ipsystbs"
                        ? _c("div", [
                            _vm.processModel.modelCode ===
                            "IpsTechnicalBusinessSecrets"
                              ? _c(
                                  "div",
                                  [
                                    _c("business-secrets", {
                                      attrs: { idFormNo: _vm.ipsys_aid },
                                      on: {
                                        handleCloseModal: function($event) {
                                          return _vm.$emit("ok")
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.processModel.applicationCode === "envinfo"
                        ? _c("div", [
                            _vm.processModel.modelCode === "trashForm"
                              ? _c(
                                  "div",
                                  [
                                    _c("epi-trash-sign-form", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "waterForm"
                              ? _c(
                                  "div",
                                  [
                                    _c("epi-water-sign-form", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "gasForm"
                              ? _c(
                                  "div",
                                  [
                                    _c("epi-gas-sign-form", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.processModel.modelCode === "wasteWaterForm"
                              ? _c(
                                  "div",
                                  [
                                    _c("epi-waste-water-sign-form", {
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.processModel.modelCode === "cfForm"
                              ? _c(
                                  "div",
                                  [
                                    _c("epi-deter-sign-form", {
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.processModel.applicationCode === "esg"
                        ? _c("div", [
                            _vm.processModel.modelCode ===
                              "esg_kpiForm_outLeader" ||
                            _vm.processModel.modelCode === "esg_kpiForm"
                              ? _c(
                                  "div",
                                  [
                                    _c("esg-kpi-sign-form", {
                                      ref: "realForm",
                                      attrs: {
                                        disabled: true,
                                        formCode: _vm.formCode,
                                        "kpi-sign-no": _vm.ipsys_aid
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode ===
                                  "esg_kpiDisForm" ||
                                _vm.processModel.modelCode ===
                                  "esg_kpiDisBgChange" ||
                                _vm.processModel.modelCode ===
                                  "esg_kpiDisBuChange" ||
                                _vm.processModel.modelCode ===
                                  "esg_kpiDisBgCancle" ||
                                _vm.processModel.modelCode ===
                                  "esg_kpiDisBuCancle"
                              ? _c(
                                  "div",
                                  [
                                    _c("esg-kpi-dis-sign-form", {
                                      ref: "realForm",
                                      attrs: {
                                        disabled: true,
                                        formCode: _vm.formCode,
                                        formNo: _vm.ipsys_aid,
                                        menuType: "waitMenu"
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.processModel.applicationCode === "sweep"
                        ? _c(
                            "div",
                            [
                              _c("sweepsys-danger-sign-form", {
                                ref: "applicationModel",
                                attrs: {
                                  formNo: _vm.ipsys_aid,
                                  formCode: _vm.formCode
                                }
                              }),
                              _c("a-form-model-item", {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.processModel.applicationCode === "labor"
                        ? _c("div", [
                            _vm.processModel.modelCode === "labor_change"
                              ? _c(
                                  "div",
                                  [
                                    _c("labor-change-manage-sign-form", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode,
                                        disabled: true,
                                        detailDisabled: _vm.disabled,
                                        "disabled-evaluate": false,
                                        "order-no": _vm.orderNo,
                                        "task-code": _vm.taskCode
                                      },
                                      on: { isAgree: _vm.isAgree }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode ===
                                "labor_change_close"
                              ? _c(
                                  "div",
                                  [
                                    _c("labor-change-manage-sign-form", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode,
                                        disabled: true,
                                        "disabled-evaluate": true,
                                        "order-no": _vm.orderNo,
                                        "task-code": _vm.taskCode
                                      },
                                      on: { isAgree: _vm.isAgree }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.processModel.applicationCode === "cst"
                        ? _c("div", [
                            _vm.processModel.modelCode === "cst_apply"
                              ? _c(
                                  "div",
                                  [
                                    _c("cst-request-order-form-sign", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_delay"
                              ? _c(
                                  "div",
                                  [
                                    _c("cst-delay-request-order-form-sign", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_report"
                              ? _c(
                                  "div",
                                  [
                                    _c("cst-report-order-form-sign", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_night"
                              ? _c(
                                  "div",
                                  [
                                    _c("cst-night-request-order-form-sign", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_survey"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "cst-survey-check-request-order-form-sign",
                                      {
                                        ref: "applicationModel",
                                        attrs: {
                                          formNo: _vm.ipsys_aid,
                                          formCode: _vm.formCode
                                        }
                                      }
                                    ),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_check"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "cst-survey-check-request-order-form-sign",
                                      {
                                        ref: "applicationModel",
                                        attrs: {
                                          formNo: _vm.ipsys_aid,
                                          taskCode: _vm.taskCode,
                                          formCode: _vm.formCode
                                        }
                                      }
                                    ),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_interrupt"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "cst-interrupt-request-order-form-sign",
                                      {
                                        ref: "applicationModel",
                                        attrs: {
                                          formNo: _vm.ipsys_aid,
                                          formCode: _vm.formCode
                                        }
                                      }
                                    ),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode ===
                                "cst_interrupt_confirm"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "cst-interrupt-request-order-form-sign",
                                      {
                                        ref: "applicationModel",
                                        attrs: {
                                          formNo: _vm.ipsys_aid,
                                          formCode: _vm.formCode
                                        }
                                      }
                                    ),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode ===
                                "cst_interrupt_recovery"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "cst-interrupt-request-order-form-sign",
                                      {
                                        ref: "applicationModel",
                                        attrs: {
                                          formNo: _vm.ipsys_aid,
                                          formCode: _vm.formCode
                                        }
                                      }
                                    ),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_flame"
                              ? _c(
                                  "div",
                                  [
                                    _c("cst-fire-request-order-sign-form", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode,
                                        disabled: _vm.disabled
                                      },
                                      on: { isAgree: _vm.isAgree }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_gas"
                              ? _c(
                                  "div",
                                  [
                                    _c("cst-gas-request-order-sign-form", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode,
                                        disabled: _vm.disabled
                                      },
                                      on: { isAgree: _vm.isAgree }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_exception"
                              ? _c(
                                  "div",
                                  [
                                    _c("cst-not-started-exception-sign-form", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode,
                                        disabled: _vm.disabled
                                      },
                                      on: { isAgree: _vm.isAgree }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_high" ||
                                _vm.processModel.modelCode === "cst_hoisting" ||
                                _vm.processModel.modelCode ===
                                  "cst_confined_space" ||
                                _vm.processModel.modelCode ===
                                  "cst_temporary_electricity"
                              ? _c(
                                  "div",
                                  [
                                    _c("special-work-sign-modal", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode,
                                        disabled: _vm.disabled
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.processModel.modelCode === "cst_carry"
                              ? _c(
                                  "div",
                                  [
                                    _c("CstDeviceCarryFormSign", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode,
                                        disabled: _vm.disabled
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.processModel.applicationCode === "food"
                        ? _c("div", [
                            _vm.processModel.modelCode === "AuditWorkflow"
                              ? _c(
                                  "div",
                                  [
                                    _c("audit-workflow-form", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.processModel.modelCode === "PutOnRecordWorkflow"
                              ? _c(
                                  "div",
                                  [
                                    _c("put-on-record-workflow-form", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.processModel.applicationCode === "showroom_platform"
                        ? _c("div", [
                            _vm.processModel.modelCode === "showroom_order"
                              ? _c(
                                  "div",
                                  [
                                    _c("showroom-order-sign-details", {
                                      ref: "applicationModel",
                                      attrs: {
                                        formNo: _vm.ipsys_aid,
                                        formCode: _vm.formCode
                                      }
                                    }),
                                    _c("a-form-model-item", {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm.processModel.applicationCode === "ipsys" &&
                  (_vm.model.task_code === "ApproveTask8" ||
                    _vm.model.task_code === "ApproveTask9") &&
                  1 === 0
                    ? _c(
                        "a-tab-pane",
                        {
                          key: "2",
                          style:
                            _vm.innerFullscreen === false
                              ? _vm.setEdit === true
                                ? "max-height: 32vh;overflow:scroll"
                                : "max-height: 45vh;overflow:scroll"
                              : _vm.setEdit === true
                              ? "max-height: 60vh;overflow:scroll"
                              : "max-height: 65vh;overflow:scroll",
                          attrs: {
                            tab: _vm.language["eletronicSigned.fileUrls"]
                          }
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c("p", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.language[
                                      "eletronicSigned.fileUrlsPrompt"
                                    ]
                                  )
                                )
                              ]),
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.language["eletronicSigned.fileUrls"],
                                    required: "",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol
                                  }
                                },
                                [
                                  _c("j-upload", {
                                    attrs: {
                                      "upload-source": "ipsys",
                                      customName: true,
                                      bizPath: "null",
                                      multiple: _vm.fileAttribute.fileMultiple,
                                      disabled:
                                        _vm.model.task_code !== "ApproveTask8"
                                    },
                                    on: { change: _vm.handleChange },
                                    model: {
                                      value: _vm.fileUrls,
                                      callback: function($$v) {
                                        _vm.fileUrls = $$v
                                      },
                                      expression: "fileUrls"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-tab-pane",
                    {
                      key: "3",
                      style:
                        _vm.innerFullscreen === false
                          ? _vm.setEdit === true
                            ? "max-height: 32vh;overflow:scroll"
                            : "max-height: 45vh;overflow:scroll"
                          : _vm.setEdit === true
                          ? "max-height: 60vh;overflow:scroll"
                          : "max-height: 65vh;overflow:scroll",
                      attrs: { tab: _vm.singTableName }
                    },
                    [
                      _c(
                        "a-card",
                        {
                          attrs: {
                            loading: _vm.loading,
                            bordered: false,
                            title: _vm.language["eletronicSigned.signList"]
                          }
                        },
                        [
                          _c("a-table", {
                            attrs: {
                              size: "middle",
                              rowKey: "id",
                              columns: _vm.columns,
                              pagination: false,
                              dataSource: _vm.dataSource,
                              loading: _vm.loading
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "approveResult",
                                fn: function(text, record) {
                                  return _c("span", {}, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          text === "Cancel"
                                            ? _vm.language[
                                                "eletronicSigned.termination"
                                              ]
                                            : _vm.langCode === "zh_CN" ||
                                              _vm.langCode === "zh_TW"
                                            ? record.actionTextLocalLang
                                            : record.actionTextEn
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-card",
                        {
                          attrs: {
                            loading: _vm.loading,
                            bordered: false,
                            title: _vm.language["eletronicSigned.signPerson"]
                          }
                        },
                        [
                          _c("a-table", {
                            attrs: {
                              columns: _vm.approverColumns,
                              size: "middle",
                              "data-source": _vm.approverData,
                              pagination: false,
                              loading: _vm.loading
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    {
                      key: "4",
                      style:
                        _vm.innerFullscreen === false
                          ? _vm.setEdit === true
                            ? "max-height: 32vh;overflow:scroll"
                            : "max-height: 45vh;overflow:scroll"
                          : _vm.setEdit === true
                          ? "max-height: 60vh;overflow:scroll"
                          : "max-height: 65vh;overflow:scroll",
                      attrs: {
                        tab: _vm.language["eletronicSigned.processChart"]
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "100%" },
                        attrs: { src: _vm.getProcessChart() }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm.urlType == "todoProcess"
                ? _c(
                    "a-card",
                    {
                      attrs: {
                        bordered: false,
                        title:
                          _vm.processModel.applicationCode === "ipsys" &&
                          _vm.model.task_code === "ApproveTask8"
                            ? ""
                            : _vm.language["eletronicSigned.signOpinion"]
                      }
                    },
                    [
                      _vm.processModel.applicationCode === "ipsys"
                        ? _c(
                            "div",
                            [
                              !(_vm.model.task_code === "ApproveTask8")
                                ? _c(
                                    "a-row",
                                    [
                                      _c("a-textarea", {
                                        model: {
                                          value: _vm.model.comments,
                                          callback: function($$v) {
                                            _vm.$set(_vm.model, "comments", $$v)
                                          },
                                          expression: "model.comments"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  !(_vm.model.task_code === "ApproveTask8")
                                    ? _c(
                                        "a-button",
                                        {
                                          staticStyle: {
                                            color: "blue",
                                            right: "20px",
                                            "padding-left": "30px",
                                            "padding-right": "30px"
                                          },
                                          on: { click: _vm.agree }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language[
                                                "eletronicSigned.agree"
                                              ]
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  !(_vm.model.task_code === "ApproveTask8")
                                    ? _c(
                                        "a-button",
                                        {
                                          staticStyle: {
                                            color: "blue",
                                            left: "20px",
                                            "padding-left": "30px",
                                            "padding-right": "30px"
                                          },
                                          on: { click: _vm.agreeAndNext }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language[
                                                "eletronicSigned.agreeAndNext"
                                              ]
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  !(_vm.model.task_code === "ApproveTask8")
                                    ? _c(
                                        "a-button",
                                        {
                                          staticStyle: {
                                            color: "red",
                                            left: "40px",
                                            "padding-left": "30px",
                                            "padding-right": "30px"
                                          },
                                          on: { click: _vm.reject }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language[
                                                "eletronicSigned.reject"
                                              ]
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.processModel.modelCode === "cst_check" &&
                          _vm.model.task_code === "Applicant"
                        ? _c(
                            "div",
                            [
                              _c(
                                "a-row",
                                [
                                  _c("a-textarea", {
                                    attrs: { maxlength: "200" },
                                    model: {
                                      value: _vm.model.comments,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "comments", $$v)
                                      },
                                      expression: "model.comments"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        right: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agree }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.agree"]
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        left: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agreeAndNext }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language[
                                            "eletronicSigned.agreeAndNext"
                                          ]
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.processModel.modelCode ===
                            "cst_interrupt_confirm" &&
                          _vm.model.task_code === "Operator"
                        ? _c(
                            "div",
                            [
                              _c(
                                "a-row",
                                [
                                  _c("a-textarea", {
                                    attrs: { maxlength: "200" },
                                    model: {
                                      value: _vm.model.comments,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "comments", $$v)
                                      },
                                      expression: "model.comments"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        right: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agree }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.agree"]
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        left: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agreeAndNext }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language[
                                            "eletronicSigned.agreeAndNext"
                                          ]
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.processModel.modelCode ===
                            "cst_interrupt_recovery" &&
                          _vm.model.task_code === "FireResponsible"
                        ? _c(
                            "div",
                            [
                              _c(
                                "a-row",
                                [
                                  _c("a-textarea", {
                                    attrs: { maxlength: "200" },
                                    model: {
                                      value: _vm.model.comments,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "comments", $$v)
                                      },
                                      expression: "model.comments"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        right: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agree }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.agree"]
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        left: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agreeAndNext }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language[
                                            "eletronicSigned.agreeAndNext"
                                          ]
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.processModel.applicationCode === "ipsystbs"
                        ? _c(
                            "div",
                            [
                              _c(
                                "span",
                                { staticStyle: { color: "#6200ff" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.language["ipsystbs.signingAlter"]
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "a-row",
                                [
                                  _c("a-textarea", {
                                    attrs: { maxlength: "300" },
                                    model: {
                                      value: _vm.model.comments,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "comments", $$v)
                                      },
                                      expression: "model.comments"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        right: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agree }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.agree"]
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        left: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agreeAndNext }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language[
                                            "eletronicSigned.agreeAndNext"
                                          ]
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        left: "40px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.reject }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.reject"]
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c(
                                "a-row",
                                [
                                  _c("a-textarea", {
                                    model: {
                                      value: _vm.model.comments,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "comments", $$v)
                                      },
                                      expression: "model.comments"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        right: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agree }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.agree"]
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        left: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agreeAndNext }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language[
                                            "eletronicSigned.agreeAndNext"
                                          ]
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        left: "40px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.reject }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.reject"]
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }